import { useMemo } from "react";
import GitHubProfileCard from "../../components/common/GitHubProfileCard";
import "./AboutPage.css";

const aboutParagraphs = [
  "I am a Flutter-focused Full Stack Developer\npassionate about building modern cross-platform applications.",
  "With experience leading frontend initiatives\nand developing scalable backend systems,\nI understand products end-to-end.",
  "I value clean architecture, thoughtful UI design,\nand efficient cloud-based solutions.",
  "For me, great software means combining\nstrong engineering with intuitive user experiences.",
];

const techIcons = [
  "/tech_icons/aws.svg",
  "/tech_icons/bloc.svg",
  "/tech_icons/c_sharp.svg",
  "/tech_icons/dart.svg",
  "/tech_icons/flutter.svg",
  "/tech_icons/git.svg",
  "/tech_icons/grpc.svg",
  "/tech_icons/riverpod.svg",
  "/tech_icons/sql.svg",
  "/tech_icons/typescript.svg",
];

function AboutPage() {
  const backgroundIcons = useMemo(() => {
    const shuffledIcons = [...techIcons].sort(() => Math.random() - 0.5);

    return shuffledIcons.map((iconSrc, index) => ({
      src: iconSrc,
      top: `${10 + Math.random() * 80}%`,
      left: `${10 + Math.random() * 80}%`,
      size: 34 + Math.floor(Math.random() * 34),
      rotation: Math.floor(Math.random() * 40) - 20,
      opacity: 0.1 + Math.random() * 0.18,
      key: `about-icon-${index}`,
    }));
  }, []);

  return (
    <section className="about-section">
      <div className="about-section__background" aria-hidden="true">
        {backgroundIcons.map((icon) => (
          <img
            key={icon.key}
            src={icon.src}
            alt=""
            className="about-section__bg-icon"
            style={{
              top: icon.top,
              left: icon.left,
              width: `${icon.size}px`,
              height: `${icon.size}px`,
              transform: `translate(-50%, -50%) rotate(${icon.rotation}deg)`,
              opacity: icon.opacity,
            }}
          />
        ))}
      </div>

      <h1 className="about-section__title">About me</h1>

      <div className="about-section__content">
        {aboutParagraphs.map((paragraph, index) => (
          <p key={index} className="about-section__paragraph">
            {paragraph}
          </p>
        ))}

        <div className="about-section__github-card">
          <GitHubProfileCard username="LarsHamb" width={760} height={320} />
        </div>
      </div>
    </section>
  );
}

export default AboutPage;
